// i18n: translated
/**
 * 新着通知ポップアップのグローバルリスナー (描画なし)。
 *
 * AppLayout 配下 (認証済み + ToastProvider 内) にマウントして、管理画面を開いている間
 * 新着通知のポーリング・ポップアップ・通知音を有効にする。表示は既存 ToastContainer を使う。
 */
import { useNotificationPopup } from '@/hooks/useNotificationPopup';
import { usePermission } from '@/hooks/usePermission';

export default function NotificationPopupListener() {
  const { canRead } = usePermission();
  return canRead('dashboard') ? <AuthorizedNotificationPopupListener /> : null;
}

function AuthorizedNotificationPopupListener(): null {
  useNotificationPopup();
  return null;
}
